import { Api } from '@/interface/api';

/**
 * 获取用户信息
 * 
 * */

const fetchRaceSys: Api = {
    url: '/api/schedule/race-sys',
    method: 'get',
};

export { fetchRaceSys }
